import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_presure",
  "use": "icon-icon_arrow_presure-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_presure\"><path d=\"M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm-.137 4.387a1 1 0 0 0-1.327.077l-.078.088a1 1 0 0 0 .078 1.327l2.12 2.12-2.12 2.122-.078.088a1 1 0 0 0 1.492 1.327l2.828-2.829.078-.087a1 1 0 0 0-.078-1.327L7.95 4.464Z\" fill=\"#F5222D\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol